// ProductDetailsButton.js
import React from 'react';
import { Typography } from "@mui/material";

const ProductDetailsButton = ({ onClick }) => {
    return (
        <Typography variant="body2" color="primary" onClick={onClick} style={{ cursor: 'pointer' }}>
            Bekijk de prijsdetails
        </Typography>
    );
};

export default ProductDetailsButton;
